import { lazy, Suspense } from 'react';
import { Outlet, Navigate } from 'react-router-dom';

import DashboardLayout from 'src/layouts/dashboard';
import { AuthGuard, OwnerGuard } from 'src/auth/guard';

import { LoadingScreen } from 'src/components/loading-screen';

// ----------------------------------------------------------------------

const CashClosePage = lazy(() => import('src/pages/owner/cash-close'));

// Owner Daily Cash Close (spec #122, slice #123). Owner-only, gated by OwnerGuard on top of AuthGuard —
// the same pattern as the billing route; the backend `OnlyOwners` policy is the real authority.
export const cashCloseRoutes = [
  {
    path: 'owner',
    element: (
      <AuthGuard>
        <OwnerGuard>
          <DashboardLayout>
            <Suspense fallback={<LoadingScreen />}>
              <Outlet />
            </Suspense>
          </DashboardLayout>
        </OwnerGuard>
      </AuthGuard>
    ),
    children: [
      { element: <Navigate to="cash-close" replace />, index: true },
      { path: 'cash-close', element: <CashClosePage /> },
    ],
  },
];
